import DepositoCreate from './DepositoCreate.vue'
export default DepositoCreate
